import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const NationalCPF = {
	name: NAME,
	apiProvider,
	router,
};
